import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { useLocalizeMessage } from 'libs.nucleus';
import { PageHeader, PageWrapper, useBooleanState } from 'libs.react';
import { DataTemplatesDashboardContent } from '../../components/data_templates_dashboard';
import { CreateTransferTemplateModal } from '../../components/data_transfer_template/create_transfer_template_modal.component';
const DataTemplatesDashboardPage = () => {
    const translate = useLocalizeMessage();
    const [isCreateTransferTemplateModalOpen, openCreateTransferTemplateModal, closeCreateTransferTemplateModal] = useBooleanState();
    const headerOptions = [
        {
            name: translate('Create template'),
            onClick: openCreateTransferTemplateModal,
            variant: 'primary',
        },
    ];
    return (_jsxs(PageWrapper, { children: [_jsx(PageHeader, { title: translate('Data templates'), subtitle: translate('Create and manage your data transfer templates'), options: headerOptions, LinkComponent: Link }), _jsx(DataTemplatesDashboardContent, {}), isCreateTransferTemplateModalOpen && _jsx(CreateTransferTemplateModal, { onClose: closeCreateTransferTemplateModal })] }));
};
export default DataTemplatesDashboardPage;
